document.addEventListener("DOMContentLoaded", function (event) {

    /**
     * Menu toggle
     */
    const toggle = document.querySelector('.c-toggle');
    const header = document.querySelector('.c-header');
    const wpadminbar = document.querySelector('#wpadminbar');
    const body = document.body;

    if (toggle && header) {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            header.classList.toggle('c-header--menu-show');
        });
    }

    if (window.innerWidth <= 768) {
        const headerLinks = header.querySelectorAll('.c-header__link');
        if (headerLinks) {
            headerLinks.forEach((el) => {
                el.addEventListener('click', () => {
                    header.classList.remove('c-header--menu-show');
                });
            });
        }
    }

    /**
     * Language switcher
     */
    const cLanguagePickers = document.querySelectorAll('.c-language-picker');

    if (cLanguagePickers.length > 0) {
        cLanguagePickers.forEach(picker => {
            const links = picker.querySelectorAll('.c-language-picker__link');
            links.forEach(link => {
                link.addEventListener('click', (e) => {
                    if (e.currentTarget.classList.contains('c-language-picker__link--active')) {
                        e.preventDefault();
                    }
                    e.currentTarget.closest('.c-language-picker').classList.toggle('c-language-picker--active');
                });
            });
        });
    }

    /**
     * Smooth scrolling
     */
    const links = document.querySelectorAll(".scrollable-link");

    const scrollToSmoothly = (pos, time) => {
        const currentPos = window.pageYOffset;
        let start = null;
        if (time == null) time = 500;
        pos = +pos, time = +time;
        window.requestAnimationFrame(function step(currentTime) {
            start = !start ? currentTime : start;
            const progress = currentTime - start;
            if (currentPos < pos) {
                window.scrollTo(0, ((pos - currentPos) * progress / time) + currentPos);
            } else {
                window.scrollTo(0, currentPos - ((currentPos - pos) * progress / time));
            }
            if (progress < time) {
                window.requestAnimationFrame(step);
            } else {
                window.scrollTo(0, pos);
            }
        });
    };

    links.forEach((el) => {
        el.addEventListener('click', (e) => {
            let offset = header.clientHeight;
            const hash = e.currentTarget.getAttribute("href").split('#');
            const scrollTarget = document.querySelector('#' + hash[1]);

            if (!scrollTarget) return;

            if (wpadminbar) {
                offset = offset + wpadminbar.clientHeight;
            }

            scrollToSmoothly(scrollTarget.offsetTop - offset, 650);
        });
    });

    /**
     * Dodanie tła po scrollu gdy nagłówek jest przeźroczysty
     */
    let scrollpos = window.scrollY;

    const addClassOnScroll = () => {
        body.classList.add("menu-top-transparent--add-bg");
    };

    const removeClassOnScroll = () => {
        body.classList.remove("menu-top-transparent--add-bg");
    };

    window.addEventListener('scroll', function () {

        scrollpos = window.scrollY;

        if (scrollpos > 5) {
            addClassOnScroll();
        } else {
            removeClassOnScroll();
        }

    });

    /**
     * Animacje
     */
    AOS.init();

    /**
     * Aktywna sekcja
     */

    const sections = document.querySelectorAll(".scrollable-section");

    const navHighlighter = () => {

        const scrollY = window.pageYOffset;

        console.log('sections: ', sections);

        sections.forEach(current => {

            let offset = header.clientHeight;
            const sectionHeight = current.offsetHeight;

            if (wpadminbar) {
                offset = offset + wpadminbar.clientHeight;
            }

            const sectionTop = current.offsetTop - offset - 1;
            sectionId = current.getAttribute("id");
           
            if (
                scrollY > sectionTop &&
                scrollY <= sectionTop + sectionHeight
            ) {
                if (document.querySelector(".c-header__link[href$=" + sectionId + "]")) {
                    document.querySelector(".c-header__link[href$=" + sectionId + "]").classList.add("c-header__link--active");
                }
            } else {
                if (document.querySelector(".c-header__link[href$=" + sectionId + "]")) {
                    document.querySelector(".c-header__link[href$=" + sectionId + "]").classList.remove("c-header__link--active");
                }
            }
        });
    };

    window.addEventListener("scroll", navHighlighter);

    /**
     * Newsletter belt
    */

    const newsletterPopup = () => {
        const popupNewsletter = document.getElementById('newsletter-belt');
        const closeBtn = document.querySelector('.js-close-newsletter-belt');
        const popupCloseCookie = localStorage.getItem("closePopup");

        if(popupNewsletter){
            if(closeBtn){
                closeBtn.addEventListener('click',(e) => { 
                const targetId = e.currentTarget.getAttribute('data-target');
                if(targetId){
                    popupNewsletter.classList.add('start-hidden');
                    setTimeout(()=>{
                        document.getElementById(targetId).classList.add('hidden');
                        document.getElementById(targetId).classList.remove('start-hidden');
                    },500);
                    localStorage.setItem("closePopup", true);
                  }
                });
            }

            if(popupCloseCookie) popupNewsletter.classList.add('hidden');
            else setTimeout(()=>{ popupNewsletter.classList.remove('start-hidden') },500); 
            
            // console.log(localStorage);
        }
    }

    newsletterPopup();
});